// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-admin-pending {
  padding: 20px;
}

.super-admin-pending h2 {
  color: #65ccb7;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.8em;
}

.section-icon {
  font-size: 1.4em;
}

.super-admin-table-container {
  overflow-x: auto;
  height: 57vh;
  overflow-y: scroll;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.super-admin-table {
  width: 100%;
  border-collapse: collapse;
}

.super-admin-table th,
.super-admin-table td {
  padding: 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.super-admin-table th {
  background-color: #f8f9fa;
  color: #333;
  font-weight: 600;
  white-space: nowrap;
}

.super-admin-table tr:hover {
  background-color: #f8f9fa;
}

.super-admin-table tr:last-child td {
  border-bottom: none;
}

.super-admin-approve-btn,
.super-admin-reject-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-right: 10px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  color: white;
  font-weight: 500;
}

.super-admin-approve-btn {
  background-color: #65ccb7;
}

.super-admin-reject-btn {
  background-color: #e74c3c;
}

.super-admin-approve-btn:hover,
.super-admin-reject-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.super-admin-approve-btn:hover {
  background-color: #55bb9f;
}

.super-admin-reject-btn:hover {
  background-color: #c0392b;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/components/PendingApprovals.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".super-admin-pending {\n  padding: 20px;\n}\n\n.super-admin-pending h2 {\n  color: #65ccb7;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.8em;\n}\n\n.section-icon {\n  font-size: 1.4em;\n}\n\n.super-admin-table-container {\n  overflow-x: auto;\n  height: 57vh;\n  overflow-y: scroll;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.super-admin-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.super-admin-table th,\n.super-admin-table td {\n  padding: 16px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.super-admin-table th {\n  background-color: #f8f9fa;\n  color: #333;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.super-admin-table tr:hover {\n  background-color: #f8f9fa;\n}\n\n.super-admin-table tr:last-child td {\n  border-bottom: none;\n}\n\n.super-admin-approve-btn,\n.super-admin-reject-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-right: 10px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: white;\n  font-weight: 500;\n}\n\n.super-admin-approve-btn {\n  background-color: #65ccb7;\n}\n\n.super-admin-reject-btn {\n  background-color: #e74c3c;\n}\n\n.super-admin-approve-btn:hover,\n.super-admin-reject-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.super-admin-approve-btn:hover {\n  background-color: #55bb9f;\n}\n\n.super-admin-reject-btn:hover {\n  background-color: #c0392b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
